import { render, staticRenderFns } from "./txt.vue?vue&type=template&id=28a10875&scoped=true&lang=pug"
import script from "./txt.vue?vue&type=script&lang=js"
export * from "./txt.vue?vue&type=script&lang=js"
import style0 from "./txt.vue?vue&type=style&index=0&id=28a10875&prod&rel=stylesheet%2Fscss&lang=scss"
import style1 from "./txt.vue?vue&type=style&index=1&id=28a10875&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a10875",
  null
  
)

export default component.exports